// FormattedDate.js
import React from "react";

/**
 * FormattedDate Component
 * @param {string} dateString - ISO date string (e.g., "2025-08-02T18:30:00.000Z")
 * @returns {JSX.Element} - A span displaying the date in "YYYY-MM-DD" format
 */
const FormattedDate = ({ dateString }) => {
  if (!dateString) return null;
  
  // Create a new Date instance from the ISO string
  const date = new Date(dateString);
  // Extract only the date part in YYYY-MM-DD format
  const formattedDate = date.toISOString().split("T")[0];
  
  return <span>{formattedDate}</span>;
};

export default FormattedDate;